import { allChillerMetricNames } from '@shared_types/metrics/chiller_metrics'
import { initializeMetrics } from '@shared_utils/metric_utils'

import { LOAD_CHILLER, UPDATE_CHILLER } from '../actions'

const initialState = initializeMetrics(allChillerMetricNames)

// @TODO fix types
export default function init (previousState = initialState, { type, payload }: { type: string; payload: unknown }) {
  if (type === LOAD_CHILLER || type === UPDATE_CHILLER) {
    console.log('init chiller', payload)
    return Object.assign({}, previousState, payload)
  } else {
    return previousState
  }
}
